import { Cta, SanityCtaProps } from "@/components/cta"
import { SocialIconLink } from "@/components/social-icon-link"
import { GridBg } from "@/svgs/grid-bg"
import { Logo } from "@/svgs/logo"
import { cn } from "@/utils/cn"
import { SanityImageAsset, SanityReference } from "sanity-codegen"

interface FooterProps {
  content: {
    bgColor: "white" | "blue"
    address: string
    info: string
    socials: {
      name: string
      url: string
      image: {
        asset: SanityReference<SanityImageAsset>
      }
    }[]
    menu1: SanityCtaProps[]
    menu2: SanityCtaProps[]
  }
}

export function Footer({ content }: FooterProps) {
  return (
    <div
      className={cn(
        "relative flex justify-center py-10 md:py-50",
        content.bgColor === "white"
          ? "bg-neutral-light text-neutral-dark"
          : "bg-primary-800 text-neutral-light"
      )}
    >
      {content.bgColor === "white" && (
        <GridBg className="absolute top-0 bottom-0 z-10 h-full w-full text-neutral-dark opacity-50" />
      )}
      <div className="z-10 mx-7 w-full max-w-[138rem] md:mx-20">
        <div
          className={cn(
            "md:border-b md:py-6",
            content.bgColor === "white"
              ? "border-neutral-dark"
              : "border-green-500"
          )}
        >
          <Logo className="h-auto w-[35rem] max-w-full md:w-[76rem]" />
        </div>
        <div className="mt-6 flex flex-col-reverse gap-6 md:mt-12 md:flex-col md:gap-8">
          <div className="-ml-3 flex justify-start font-family-gtpressura text-xmd md:flex-row">
            <div className="flex w-1/2 flex-col md:w-auto md:flex-row">
              {content.menu1.map((link, i) => (
                <Cta
                  variant="ghost"
                  className={cn(
                    "px-3 py-3 md:py-4",
                    content.bgColor === "white" && "text-neutral-dark"
                  )}
                  sanity={link}
                  key={i}
                />
              ))}
            </div>
            <div className="flex w-1/2 flex-col md:w-auto md:flex-row">
              {content.menu2.map((link, i) => (
                <Cta
                  variant="ghost"
                  className={cn(
                    "px-3 py-3 md:py-4",
                    content.bgColor === "white" && "text-neutral-dark"
                  )}
                  sanity={link}
                  key={i}
                />
              ))}
            </div>
          </div>
          <div>
            <p className="text-sm font-bold md:text-md">{content.address}</p>
            <p className="mt-2 text-sm font-bold md:text-md">{content.info.replace("${year}", String(new Date().getFullYear()))}</p>
            <div className="mt-4 flex items-center justify-start gap-8 md:mt-8">
              {content.socials.map((social, i) => (
                <SocialIconLink
                  key={i}
                  url={social.url}
                  asset={social.image.asset}
                  color={content.bgColor === "white" ? "blue" : "white"}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
